import {
  Card,
  DialogActions,
  FormControl,
  FormGroup,
  Grid,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { get, getLogs } from "../../api/apiCaller";
import { mapActionsToProps } from "../../redux/campaigns";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  grid: {
    justifyContent: "center",
  },
});

class CampaignService extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      agents: [],
      startAt: new Date(),
      endAt: new Date(),
      checked: [],
      callsPerAgent: "",
      checkA: false,
      checkB: false,
      loadingService: false,
      code: "",
      checkValidate: null,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "name", numeric: true, disablePadding: false, label: "Loại dịch vụ" },
    {
      id: "code",
      numeric: true,
      disablePadding: true,
      label: "Ký hiệu dịch vụ",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit = () => {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({ time: { gte: this.state.filters.where.from } });
                  where.and = and;
                } else {
                  and.push({ time: { lte: this.state.filters.where.to } });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListCampaignsService(
      filters.order,
      filters.pageSize,
      filters.page,
      {
        where,
      }
    );
    this.props.countListCampaignsService({ where: where });
  };

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({ modalSend: false, modalAction: false, modalDelete: false });
  };

  openModalEdit = (item) => {
    // this.state.item = item
    this.setState({
      modalAction: true,
      item: item,
      service: { ...item },
      checkValidate: null,
    });
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
      if (name === "code") {
        this.validateSymbol(e.target.value)
          .then((res) => this.setState({ checkValidate: res }))
          .catch((err) => this.setState({ checkValidate: err }));
      }
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
      if (name === "code") {
        this.validateSymbol(e.target.value)
          .then((res) => this.setState({ checkValidate: res }))
          .catch((err) => this.setState({ checkValidate: err }));
      }
    };
  };

  handleCreateModel = () => {
    this.setState({
      modalAction: true,
      item: {},
      name: "",
      code: "",
      service: {},
      checkValidate: null,
    });
  };

  handleAction = () => {
    const { id } = this.state.item;
    if (this.state.checkValidate && this.state.checkValidate.result) {
      if (!id) {
        const { name, code } = this.state;
        this.validateSymbol(code)
          .then((res) => {
            this.setState({ checkValidate: res });
            if (res.result) {
              return (
                this.props.addNewCampaignService(name, code),
                setTimeout(
                  function () {
                    this.setState({ modalAction: false });
                    this.itemInit();
                  }.bind(this),
                  500
                )
              );
            }
          })
          .catch((err) => this.setState({ checkValidate: err }));
      } else {
        const { id, name, code } = this.state.item;
        this.validateSymbol(code)
          .then((res) => {
            this.setState({ checkValidate: res });
            if (res.result) {
              return (
                this.props.editCampaignService(id, name, code),
                setTimeout(
                  function () {
                    this.setState({ modalAction: false });
                    this.itemInit();
                  }.bind(this),
                  500
                )
              );
            }
          })
          .catch((err) => this.setState({ checkValidate: err }));
      }
    } else {
      if (id) {
        const { id, name, code } = this.state.item;
        this.validateSymbol(code)
          .then((res) => {
            this.setState({ checkValidate: res });
            if (res.result) {
              return (
                this.props.editCampaignService(id, name, code),
                setTimeout(
                  function () {
                    this.setState({ modalAction: false });
                    this.itemInit();
                  }.bind(this),
                  500
                )
              );
            }
          })
          .catch((err) => this.setState({ checkValidate: err }));
      }
    }
  };

  handleDownload = (item) => {
    this.setState(
      {
        loadingService: true,
      },
      () => {
        get(
          `mini-crm/interactive-log/export-interactive-log?campaignId=${item.id}`
        )
          .then((data) => {
            window.location.href = `https://api-connect.io/media-mgt/container/mini-crm/download/${data.data}`;
            this.setState({
              loadingService: false,
            });
          })
          .catch((error) => {
            this.setState({
              loadingService: false,
            });
          });
      }
    );
  };

  handleDelete = () => {
    this.props.deleteCampaignService(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleDateChangeFrom = (date) => {
    this.setState({ startAt: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleDateChangeTo = (date) => {
    this.setState({ endAt: datetimeHelper.toFormat(date, "YYYY-MM-DD") });
  };

  handleDateChangeFromEdit = (date) => {
    this.setState({
      item: {
        ...this.state.item,
        startAt: datetimeHelper.toFormat(date, "YYYY-MM-DD"),
      },
    });
  };

  handleDateChangeToEdit = (date) => {
    this.setState({
      item: {
        ...this.state.item,
        endAt: datetimeHelper.toFormat(date, "YYYY-MM-DD"),
      },
    });
  };

  handleConfig = (item) => {
    this.history.push(
      `${process.env.REACT_APP_PATH}/mini-crm/campaign-config/${item.id}`
    );
  };

  handleSelectedItem = (item) => {
    this.state.agents = item;
  };

  handleToggle = (value) => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked,
    });
  };

  handleToggleChecked = (value) => {
    const { listAgent, checked } = this.state.item;
    const currentIndex = listAgent.indexOf(value);
    let newChecked;
    newChecked = listAgent;
    if (currentIndex === -1) {
      newChecked = listAgent.filter((i) => i.id !== value.id);
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      item: {
        ...this.state.item,
        listAgent: newChecked,
      },
    });
  };

  handlePlay = async (item) => {
    const { id, isRunning, name, note, callsPerAgent, startAt, endAt, agents } =
      item;
    this.props.editCampaign(
      id,
      true,
      name,
      note,
      callsPerAgent,
      startAt,
      endAt,
      agents
    );
    setTimeout(
      function () {
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handlePause = async (item) => {
    const { id, isRunning, name, note, callsPerAgent, startAt, endAt, agents } =
      item;
    this.props.editCampaign(
      id,
      false,
      name,
      note,
      callsPerAgent,
      startAt,
      endAt,
      agents
    );
    setTimeout(
      function () {
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleCheckStage = (name) => {
    return (e) => {
      this.setState({
        callsPerAgent: e.target.value,
        checkA: !this.state.checkA,
        checkB: !this.state.checkB,
      });
    };
  };

  handleCheckStageEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          callsPerAgent: e.target.value,
        },
        checkA: !this.state.checkA,
        checkB: !this.state.checkB,
      });
    };
  };

  handleToggleAll = (event) => {
    const { listAgents } = this.props;
    const listAgentResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    if (event.target.checked) {
      this.setState({
        checked: listAgentResult.map((n) => n),
        item: {
          ...this.state.item,
          listAgent: listAgentResult.map((n) => n),
        },
      });
      return;
    }
    this.setState({
      checked: [],
      item: {
        ...this.state.item,
        listAgent: [],
      },
    });
  };

  onHandleKeyPress = (e) => {
    if (e.key === "Enter") {
      this.handleSubmit();
    }
  };

  validateSymbol = (text) =>
    new Promise((res, rej) => {
      if (
        text &&
        (!this.state.service.code ||
          this.state.service.code.toLowerCase() !== text.toLowerCase())
      ) {
        getLogs("/mini-crm/campaign-service/checkCampaignServiceCode", null, {
          code: text,
        })
          .then((response) => res(response.data))
          .catch((err) => rej(err));
      } else {
        setTimeout(() => res({ result: 1 }), 1000);
      }
    });

  render() {
    const { classes, campaignsService, countService } = this.props;
    const { name, filters, item, modalDelete, code } = this.state;
    const listCampaignResult =
      typeof campaignsService === "object"
        ? Object.keys(campaignsService).map((key) => campaignsService[key])
        : campaignsService;
    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <Grid container spacing={24}>
                    <Grid item md={3}>
                      <TextValidator
                        id="outlined-full-width"
                        margin="normal"
                        label="Tên loại dịch vụ"
                        variant="outlined"
                        className={classes.input}
                        onChange={this.handleSearch}
                        value={filters.where.name}
                        name="name"
                        onKeyPress={(e) => this.onHandleKeyPress(e)}
                      />
                    </Grid>
                    <Grid item md={3}>
                      <Tooltip title="Tìm kiếm" disableFocusListener>
                        <Fab
                          color="primary"
                          aria-label="Search"
                          className={classes.fab}
                          onClick={this.handleSubmit}>
                          <Search />
                        </Fab>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        <TableData
          {...this.props}
          nameTable="Danh sách dịch vụ chiến dịch"
          items={listCampaignResult}
          rowsPerPage={filters.pageSize}
          count={countService}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleConfig={this.handleConfig}
          handlePlay={this.handlePlay}
          handlePause={this.handlePause}
          handleDownload={this.handleDownload}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={this.state.modalAction}
          fullScreen={false}
          title={
            item
              ? item.id
                ? "Chỉnh sửa thông tin dịch vụ chiến dịch"
                : "Thêm dịch vụ chiến dịch"
              : null
          }
          onClose={() => this.setState({ modalAction: false })}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextValidator
                      label="Tên loại"
                      variant="outlined"
                      className={classes.input}
                      autoFocus={true}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("name")
                            : this.handleChangeText("name")
                          : null
                      }
                      value={item ? (item.id ? item.name : name) : ""}
                      name="name"
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                    />
                  </Grid>
                  <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                    <TextValidator
                      label="Ký hiệu dịch vụ"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("code")
                            : this.handleChangeText("code")
                          : null
                      }
                      name="code"
                      value={item ? (item.id ? item.code : code) : ""}
                      validators={["required"]}
                      errorMessages={[`Không được để trống`]}
                    />
                    {this.state.checkValidate &&
                      this.state.checkValidate.result === 0 &&
                      (item.id ? item.code : code) && (
                        <p className="error-messages">
                          Ký hiệu đã được sử dụng
                        </p>
                      )}
                    {function () {
                      let myInterval = setInterval(() => {
                        this.validateSymbol(
                          item ? (item.id ? item.code : code) : null
                        ).then((res) => {
                          this.setState({ checkValidate: res });
                        });
                        clearInterval(myInterval);
                      }, 1000);
                    }}
                  </Grid>
                </Grid>
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa dịch vụ chiến dịch?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog open={this.props.loadingService} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

CampaignService.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  ...state.campaign,
});

export default connect(
  mapStateToProps,
  mapActionsToProps
)(withStyles(styles)(CampaignService));
